var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelebration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M251.138,110.305c-9.232,0-16.722-7.49-16.722-16.722V26.696c0-9.232,7.49-16.722,16.722-16.722 s16.722,7.49,16.722,16.722v66.888C267.86,102.815,260.37,110.305,251.138,110.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M52.354,162.942c-2.842,0-5.716-0.719-8.35-2.243L8.971,140.471 c-8.002-4.616-10.734-14.839-6.118-22.84c4.616-8.013,14.849-10.734,22.84-6.118l35.033,20.228 c8.002,4.616,10.734,14.839,6.118,22.84C63.753,159.948,58.124,162.942,52.354,162.942z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M495.267,418.658c-2.842,0-5.716-0.719-8.35-2.243l-70.666-40.804 c-8.002-4.616-10.734-14.839-6.118-22.84c4.605-8.002,14.86-10.734,22.84-6.118l70.666,40.804 c8.002,4.616,10.734,14.839,6.118,22.84C506.665,415.665,501.036,418.658,495.267,418.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M133.764,480.266c-2.842,0-5.716-0.719-8.35-2.243c-8.002-4.616-10.734-14.839-6.118-22.84 l23.657-40.978c4.605-8.002,14.86-10.734,22.84-6.118c8.002,4.616,10.734,14.839,6.118,22.84l-23.657,40.978 C145.163,477.272,139.534,480.266,133.764,480.266z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M351.149,103.74c-2.842,0-5.716-0.719-8.35-2.243c-8.002-4.616-10.734-14.839-6.118-22.84 l32.073-55.543c4.616-8.012,14.849-10.734,22.84-6.118c8.002,4.616,10.734,14.839,6.118,22.84l-32.073,55.543 C362.547,100.747,356.919,103.74,351.149,103.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M484.935,277.524h-66.888c-9.232,0-16.722-7.49-16.722-16.722c0-9.232,7.49-16.722,16.722-16.722 h66.888c9.232,0,16.722,7.49,16.722,16.722C501.657,270.034,494.167,277.524,484.935,277.524z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M83.609,277.524H16.722C7.49,277.524,0,270.034,0,260.802c0-9.232,7.49-16.722,16.722-16.722h66.888 c9.232,0,16.722,7.49,16.722,16.722C100.331,270.034,92.841,277.524,83.609,277.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M386.128,511.739c-5.77,0-11.388-2.994-14.49-8.35l-41.402-71.634 c-4.616-8.002-1.883-18.225,6.108-22.851c7.98-4.616,18.214-1.894,22.851,6.108l41.402,71.634 c4.616,8.002,1.883,18.225-6.108,22.851C391.854,511.021,388.969,511.739,386.128,511.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M183.952,161.647c-5.77,0-11.388-2.994-14.49-8.35l-50.166-86.789 c-4.616-8.002-1.883-18.225,6.108-22.851c7.991-4.616,18.225-1.883,22.851,6.108l50.166,86.789 c4.616,8.002,1.883,18.225-6.108,22.851C189.678,160.928,186.794,161.647,183.952,161.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M391.027,196.592c-5.77,0-11.388-2.994-14.49-8.35c-4.616-8.002-1.883-18.225,6.108-22.851 l88.868-51.374c7.98-4.616,18.225-1.883,22.851,6.108c4.616,8.002,1.883,18.225-6.108,22.851l-88.868,51.374 C396.753,195.874,393.869,196.592,391.027,196.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36D9D9"
    },
    d: "M48.174,394.577c-5.77,0-11.388-2.994-14.49-8.35c-4.616-8.002-1.883-18.225,6.108-22.851 l77.578-44.843c7.991-4.616,18.225-1.894,22.851,6.108c4.616,8.002,1.883,18.225-6.108,22.851l-77.578,44.843 C53.9,393.858,51.015,394.577,48.174,394.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A926"
    },
    d: "M494.646,40.63l11.822-11.822c6.532-6.532,6.532-17.114,0-23.646c-6.532-6.532-17.114-6.532-23.646,0 L471,16.985L459.178,5.161c-6.532-6.532-17.114-6.532-23.646,0s-6.532,17.114,0,23.646l11.822,11.822l-11.822,11.822 c-6.532,6.532-6.532,17.114,0,23.646c3.266,3.266,7.545,4.9,11.822,4.9s8.557-1.633,11.822-4.9L471,64.276l11.822,11.822 c3.266,3.266,7.545,4.9,11.822,4.9s8.557-1.633,11.822-4.9c6.532-6.532,6.532-17.114,0-23.646L494.646,40.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6698"
    },
    cx: 72.462,
    cy: 82.435,
    r: 16.722
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6698"
    },
    cx: 27.87,
    cy: 37.843,
    r: 16.722
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E65C89"
    },
    cx: 473.787,
    cy: 483.765,
    r: 16.722
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E65C89"
    },
    cx: 429.195,
    cy: 439.173,
    r: 16.722
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC033"
    },
    d: "M316.791,380.25c-2.668,0-5.334-0.631-7.783-1.916l-58.179-30.602l-58.179,30.602 c-5.64,2.95-12.443,2.46-17.615-1.274c-5.149-3.745-7.73-10.081-6.652-16.363l11.116-64.786l-47.063-45.876 c-4.562-4.441-6.205-11.093-4.235-17.147c1.97-6.053,7.207-10.462,13.499-11.376l65.048-9.45l29.089-58.951 c2.809-5.704,8.622-9.319,14.991-9.319s12.182,3.614,14.991,9.319l29.089,58.951l65.048,9.45 c6.293,0.914,11.529,5.323,13.499,11.376c1.97,6.053,0.327,12.704-4.235,17.147l-47.063,45.876l11.116,64.786 c1.078,6.282-1.503,12.617-6.652,16.363C323.704,379.172,320.252,380.25,316.791,380.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6698"
    },
    cx: 108.692,
    cy: 182.214,
    r: 16.722
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E65C89"
    },
    cx: 317.716,
    cy: 143.753,
    r: 16.722
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E65C89"
    },
    cx: 376.243,
    cy: 327.694,
    r: 16.722
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC033"
    },
    d: "M65.451,469.826l11.822-11.822c6.532-6.532,6.532-17.114,0-23.646 c-6.532-6.532-17.114-6.532-23.646,0L41.805,446.18l-11.822-11.822c-6.532-6.532-17.114-6.532-23.646,0s-6.532,17.114,0,23.646 l11.822,11.822L6.336,481.648c-6.532,6.532-6.532,17.114,0,23.646c3.266,3.266,7.545,4.9,11.822,4.9s8.557-1.633,11.822-4.9 l11.823-11.822l11.822,11.822c3.266,3.266,7.545,4.9,11.822,4.9s8.557-1.633,11.822-4.9c6.532-6.532,6.532-17.114,0-23.646 L65.451,469.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A926"
    },
    d: "M309.007,378.334c2.449,1.284,5.117,1.916,7.783,1.916c3.461,0,6.913-1.078,9.83-3.189 c5.149-3.745,7.73-10.081,6.652-16.363l-11.116-64.786l47.063-45.876c4.562-4.441,6.205-11.093,4.235-17.147 s-7.207-10.462-13.499-11.376l-65.048-9.45l-29.089-58.951c-2.809-5.704-8.622-9.319-14.991-9.319v203.939L309.007,378.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43BFBF"
    },
    d: "M267.86,93.583V26.696c0-9.232-7.49-16.722-16.722-16.722v100.331 C260.37,110.305,267.86,102.815,267.86,93.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#736056"
    },
    d: "M251.138,511.631c-9.232,0-16.722-7.49-16.722-16.722v-91.872c0-9.232,7.49-16.722,16.722-16.722 s16.722,7.49,16.722,16.722v91.872C267.86,504.14,260.37,511.631,251.138,511.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#665247"
    },
    d: "M267.86,494.909v-91.872c0-9.232-7.49-16.722-16.722-16.722v125.316 C260.37,511.631,267.86,504.14,267.86,494.909z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/Celebration.7dc3dbd8.svg";
export { ForwardRef as ReactComponent };